<app-icon-card class="col-md-8 offset-md-2 mb-3" headline="select_add_customer">
    <div class="d-flex flex-column w-100">
        <app-customer-form [countries]="countries"
                          submitButtonLabel="select_customer_create_next_button"
                          [showInvoiceMail]="false"
                          [showElectronicInvoiceMail]="false"
                          (formSubmit)="onCreate($event)"
        >
            <ng-content></ng-content>
        </app-customer-form>
    </div>
</app-icon-card>